import { useContext } from 'react';
import { AvailablePerksContext, RewardsAndOffersContext } from '../contexts';
export var useRewardsAndOffers = function () {
    var context = useContext(RewardsAndOffersContext);
    if (!context) {
        throw new Error('useRewardsAndOffers must be used within a RewardsAndOffersProvider');
    }
    return context;
};
export var useAvailablePerks = function () {
    var context = useContext(AvailablePerksContext);
    if (!context) {
        throw new Error('availablePerks must be used within a AvailablePerksProvider');
    }
    return context;
};
export var useBenefitTag = function (benefitTag) {
    var _a, _b, _c;
    var rewardsAndOffers = ((_a = useContext(RewardsAndOffersContext)) !== null && _a !== void 0 ? _a : {}).rewardsAndOffers;
    var benefitTagsList = (_b = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _b === void 0 ? void 0 : _b.benefitTags;
    var tagIndex = benefitTagsList === null || benefitTagsList === void 0 ? void 0 : benefitTagsList.findIndex(function (tag) { return tag.tagName === benefitTag; });
    if (tagIndex > -1)
        return (_c = benefitTagsList[tagIndex]) === null || _c === void 0 ? void 0 : _c.value;
    return null;
};
